<script setup lang="ts">
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const route = useRoute()
const router = useRouter()

const menuItems = [
  { path: '/', icon: '🏠', label: '首页' },
  { path: '/workspace', icon: '🖥️', label: '工作台' },
  { path: '/apps', icon: '📦', label: '应用市场' },
  { path: '/billing', icon: '💰', label: '计费中心' },
  { path: '/developer', icon: '🔧', label: '开发者平台' },
]

const activePath = computed(() => route.path)

function navigate(path: string): void {
  router.push(path)
}
</script>

<template>
  <aside class="app-sidebar">
    <nav class="app-sidebar__nav">
      <div
        v-for="item in menuItems"
        :key="item.path"
        class="app-sidebar__item"
        :class="{ 'app-sidebar__item--active': activePath === item.path }"
        @click="navigate(item.path)"
      >
        <span class="app-sidebar__icon">{{ item.icon }}</span>
        <span class="app-sidebar__label">{{ item.label }}</span>
      </div>
    </nav>
  </aside>
</template>

<style scoped lang="scss">
.app-sidebar {
  background-color: var(--aw-bg-base);
  border-right: 1px solid var(--aw-border-default);
  padding: var(--aw-space-2);

  &__nav {
    display: flex;
    flex-direction: column;
    gap: var(--aw-space-1);
  }

  &__item {
    display: flex;
    align-items: center;
    gap: var(--aw-space-3);
    padding: var(--aw-space-2) var(--aw-space-3);
    border-radius: var(--aw-radius-md);
    cursor: pointer;
    transition: all var(--aw-duration-fast);
    color: var(--aw-text-secondary);
    font-size: var(--aw-text-sm);

    &:hover {
      background-color: var(--aw-bg-muted);
      color: var(--aw-text-primary);
    }

    &--active {
      background-color: var(--aw-primary-50);
      color: var(--aw-primary-600);
      font-weight: var(--aw-font-medium);
    }
  }

  &__icon {
    font-size: 18px;
    line-height: 1;
  }
}
</style>
